import claimAbi from "./abis/claim.json";
import merkleAbi from "./abis/merkle-contract.json";

const abis = {
  claim: claimAbi,
  merkle: merkleAbi
};

export default abis;
